import { Box, Flex, styled } from '@ghq-abi/design-system';

export const StyledWrapper = styled(Flex, {
  pt: '$appHeaderHeight',
  minHeight: '100vh'
});

export const StyledContent = styled(Box, {
  flex: 1,
  width: '100%',
  maxWidth: '100%',
  p: '$md',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FBFAFC',
  overflowX: 'hidden', // Previne apenas scroll horizontal, permite vertical

  '@tabletSm': {
    p: '$8 $lg $lg calc($appMenuClosedWidth + $lg)'
  },

  // Container responsivo: centraliza em telas grandes
  // Garante melhor legibilidade e evita espaçamentos estranhos
  '@media (min-width: 1920px)': {
    maxWidth: '1440px',
    marginLeft: 'auto',
    marginRight: 'auto',
    px: '$lg'
  },

  // Para telas ultrawides (2560px+)
  '@media (min-width: 2560px)': {
    maxWidth: '1600px',
    px: '$xl'
  },

  // Para telas muito grandes (3440px+)
  '@media (min-width: 3440px)': {
    maxWidth: '1800px',
    px: '$2xl'
  }
});
